import { createContext } from 'react';
import { ContextValue } from './types';

const ApiKeyModalFormContext = createContext<ContextValue | null>(null);
export default ApiKeyModalFormContext;

export const ApiKeyModalFormProvider = ApiKeyModalFormContext.Provider;
